<script>



	



export let w = 400
export let h = 600
export let tile = 50
export let circle = false
	
	//divide the space up equally


let rows = Math.ceil(h/tile)
let cols = Math.ceil(w/tile)

 
let fullw = tile*cols
let fullh = tile* rows

let xshift = fullw-w
let yshift = fullh-h
 
function randomColor(){
		return ("rgba(0,0,0,"+Math.random()+")" );
	}
	
	function randomNumber() {
		return Math.floor(Math.random() * 360);
	}
	

</script>

<svg viewbox="0 0 {w} {h}">
<rect width="{w}" height="{h}" x=0 y=0 fill="#eee"/>
	
	{#each Array(rows) as _, i}
		{#each Array(cols) as _, ii}
		{#if !circle}
		
		<g transform="translate({(tile*ii)-(xshift/2)} {(tile*i)-(yshift/2)})">	
				<rect width="{tile}" height="{tile}" x=0 fill="{randomColor()}"/>
		</g>

				{:else}
				<g transform="translate({(tile*ii)+(tile/2)} {(tile*i)+(tile/2)})">	
				<circle r="{tile/2}" x={tile/2} y=0 fill="{randomColor()}"   />
				</g>
			
		{/if}
				
			
		{/each}	
	{/each}
</svg>

